export interface CommandGeneratorSchema {
  name: string;
}
